import script from "./AnnotatorHost18170.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnnotatorHost18170.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__